import { Injectable, NgZone, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/app-tick-scheduler.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Angular doesn't appear to have a way of scheduling a tick to be run asynchronously.
 *
 * Instead, all the APIs that make the application tick, do it synchronously.
 *
 * This is the only way I found to schedule a tick so I decided to abstract it into a service.
 */
import * as ɵngcc0 from '@angular/core';
class AppTickScheduler {
    /**
     * @param {?} ngZone
     */
    constructor(ngZone) {
        this.ngZone = ngZone;
    }
    /**
     * @return {?}
     */
    scheduleTick() {
        if (this.frameRequest)
            return;
        this.ngZone.runOutsideAngular((/**
         * @return {?}
         */
        () => {
            this.frameRequest = requestAnimationFrame((/**
             * @return {?}
             */
            () => {
                delete this.frameRequest;
                this.ngZone.run((/**
                 * @return {?}
                 */
                () => { }));
            }));
        }));
    }
}
AppTickScheduler.ɵfac = function AppTickScheduler_Factory(t) { return new (t || AppTickScheduler)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
AppTickScheduler.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AppTickScheduler, factory: AppTickScheduler.ɵfac });
/** @nocollapse */
AppTickScheduler.ctorParameters = () => [
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppTickScheduler, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AppTickScheduler.prototype.frameRequest;
    /**
     * @type {?}
     * @private
     */
    AppTickScheduler.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/app-tick-scheduler.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AppTickSchedulerModule {
}
AppTickSchedulerModule.ɵfac = function AppTickSchedulerModule_Factory(t) { return new (t || AppTickSchedulerModule)(); };
AppTickSchedulerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AppTickSchedulerModule });
AppTickSchedulerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [AppTickScheduler] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppTickSchedulerModule, [{
        type: NgModule,
        args: [{
                providers: [AppTickScheduler]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: egovsolutions-angular-app-tick-scheduler.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AppTickScheduler, AppTickSchedulerModule };

